import React, { useState } from "react";
import {
  Button,
  Modal,
  TextField,
  Typography,
  Grid,
  Box,
  SvgIcon,
  IconButton,
  Link,
  InputAdornment,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";
import GoogleIcon from "@mui/icons-material/Google";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import leafLeft from "../../Asset/icon/leafLeft.svg";
import leafRight from "../../Asset/icon/leafRight.svg";
import { useDispatch } from "react-redux";
import { RegisterNew, LoginNew, getUserDetail } from "../../redux/Auth/AuthSlice";
import { useTranslation } from "react-i18next";
import "../../Asset/scss/takemyyacht.scss";
import ForgotPasswordModal from "./forgotPass";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

const LoginModal = ({ open, onClose, onSignUp }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");
  const [loading, setLoading] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [error, setError] = useState("");

  const handleCustomGoogleLogin = () => {
    const client = window.google.accounts.oauth2.initTokenClient({
      client_id:
        "668660044518-0mh6uijr15pbrv3s1arirs5al9hqkp1u.apps.googleusercontent.com",
      scope: "openid email profile",
      callback: async (tokenResponse) => {
        if (tokenResponse.access_token) {
          try {
            // ดึงข้อมูล profile
            const res = await fetch(
              "https://www.googleapis.com/oauth2/v3/userinfo",
              {
                headers: {
                  Authorization: `Bearer ${tokenResponse.access_token}`,
                },
              }
            );
            const profile = await res.json();
            const { email, given_name, family_name } = profile;

            await dispatch(
              RegisterNew({
                firstname: given_name,
                lastname: family_name,
                email,
                password: "",
                receiveEmail: 1,
                provider: "google",
              })
            );

            const dataLogin = await dispatch(
              LoginNew({
                email,
                firstname: given_name,
                lastname: family_name,
                provider: "google",
              })
            );

            // const dataLogin = await dispatch(
            //   LoginNew({
            //     email,
            //     firstname: given_name,
            //     lastname: family_name,
            //     provider: "google",
            //   })
            // );

            if (dataLogin.status) {
              const dataUser = await dispatch(
                getUserDetail({ token: dataLogin.token })
              );
              if (dataUser.status) {
                setSnackbarMessage(t("Login successful"));
                setSnackbarSeverity("success");
                handleClose();
              } else {
                setSnackbarMessage(t("Failed to fetch user details"));
                setSnackbarSeverity("error");
              }
            } else {
              setSnackbarMessage(t("Login failed"));
              setSnackbarSeverity("error");
            }
          } catch (err) {
            console.error(err);
            setSnackbarMessage(t("An error occurred"));
            setSnackbarSeverity("error");
          }
        } else {
          setSnackbarMessage(t("Google login was unsuccessful"));
          setSnackbarSeverity("error");
        }
        setSnackbarOpen(true);
      },
    });

    client.requestAccessToken({ prompt: "select_account consent" });
    // จะเปิด popup ให้เลือกบัญชีทันที
  };

  const handleLogin = async () => {
    if (!username && !password) {
      setUsernameError(t("Please enter your username"));
      setPasswordError(t("Please enter your password"));
      setSnackbarMessage(t("Please enter your username and password"));
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    } else if (!username) {
      setUsernameError(t("Please enter your username"));
      setSnackbarMessage(t("Please enter your username"));
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    } else if (!password) {
      setPasswordError(t("Please enter your password"));
      setSnackbarMessage(t("Please enter your password"));
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    setLoading(true);
    const dataLogin = await dispatch(
      LoginNew({ email: username, password: password })
    );

    if (dataLogin.status) {
      const dataUser = await dispatch(
        getUserDetail({ token: dataLogin.token })
      );
      if (dataUser.status) {
        setLoading(false);
        handleClose();
      }
    } else {
      setSnackbarMessage(t("Login failed, please try again"));
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setLoading(false);
    }
  };

  const handleFacebookLogin = async (response) => {
    if (response.accessToken) {
      try {

        await dispatch(
          RegisterNew({
            firstname: response.first_name,
            lastname: response.last_name,
            email: response.email,
            password: "",
            receiveEmail: 1,
            provider: "facebook",
          })
        );

        const dataLogin = await dispatch(
          LoginNew({
            email: response.email,
            firstname: response.first_name,
            lastname: response.last_name,
            provider: "facebook",
          })

        );
        // const dataLogin = await dispatch(
        //   LoginNew({
        //     email: response.email,
        //     firstname: response.first_name,
        //     lastname: response.last_name,
        //     provider: "facebook",
        //   })
        // );

        if (dataLogin.status) {
          const dataUser = await dispatch(
            getUserDetail({ token: dataLogin.token })
          );
          if (dataUser.status) {
            setSnackbarMessage(t("Login successful"));
            setSnackbarSeverity("success");
            handleClose();
          } else {
            setSnackbarMessage(t("Failed to fetch user details"));
            setSnackbarSeverity("error");
          }
        } else {
          setSnackbarMessage(t("Login failed"));
          setSnackbarSeverity("error");
        }
      } catch (error) {
        console.error(error);
        setSnackbarMessage(t("An error occurred"));
        setSnackbarSeverity("error");
      }
    } else {
      setSnackbarMessage(t("Facebook login was unsuccessful"));
      setSnackbarSeverity("error");
    }

    setSnackbarOpen(true);
  };

  // const handleGoogleLogin = async (response) => {
  //   if (response.credential) {
  //     try {
  //       const decodedToken = jwtDecode(response.credential);
  //       const { email, given_name, family_name } = decodedToken;

  //       // Call your backend to authenticate with Google token
  //       const dataLogin = await dispatch(
  //         LoginNew({
  //           email: email,
  //           firstname: given_name,
  //           lastname: family_name,
  //           provider: "google",
  //         })
  //       );

  //       if (dataLogin.status) {
  //         const dataUser = await dispatch(
  //           getUserDetail({ token: dataLogin.token })
  //         );
  //         if (dataUser.status) {
  //           setSnackbarMessage(t("Login successful"));
  //           setSnackbarSeverity("success");
  //           handleClose();
  //         } else {
  //           setSnackbarMessage(t("Failed to fetch user details"));
  //           setSnackbarSeverity("error");
  //         }
  //       } else {
  //         setSnackbarMessage(t("Login failed"));
  //         setSnackbarSeverity("error");
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       setSnackbarMessage(t("An error occurred"));
  //       setSnackbarSeverity("error");
  //     }
  //   } else {
  //     setSnackbarMessage(t("Google login was unsuccessful"));
  //     setSnackbarSeverity("error");
  //   }

  //   setSnackbarOpen(true);
  // };

  const handleForgotPasswordOpen = () => setForgotPasswordOpen(true);
  const handleForgotPasswordClose = () => setForgotPasswordOpen(false);

  const handleSignUp = () => {
    onSignUp();
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleClose = () => {
    setModalOpen(false);
    onClose();
    setUsername("");
    setPassword("");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="login-modal-title"
        aria-describedby="login-modal-description"
      >
        <div className="modalContentLG">
          <IconButton className="iconButtonClose" onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <div className="d-flex align-items-center centerAlign">
            <img
              className="img-fluid"
              draggable={false}
              src={leafLeft}
              alt="leftImage"
            />
            <h3 className="textColorPrimary m-2">{t("Login")}</h3>
            <img
              className="img-fluid"
              draggable={false}
              src={leafRight}
              alt="rightImage"
            />
          </div>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                className="textField"
                size="medium"
                label={t("Username")}
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  if (e.target.value) setUsernameError("");
                }}
                error={!!usernameError}
                helperText={usernameError}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className="textField"
                size="medium"
                label={t("Password")}
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (e.target.value) setPasswordError("");
                }}
                error={!!passwordError}
                helperText={passwordError}
                fullWidth
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>

          <div className="text-right mt-8">
            <Typography
              variant="body2"
              color="error"
              onClick={handleForgotPasswordOpen}
              className="cursor-pointer"
            >
              {t("Forgot Password?")}
            </Typography>
          </div>

          <Button
            variant="contained"
            onClick={handleLogin}
            className="buttonSubmit"
            fullWidth
          >
            {loading ? <CircularProgress size={24} /> : t("Login")}
          </Button>

          <Box className="boxDivider">
            <Box className="dividerLine" />
            <Typography variant="body2" className="orText">
              {t("OR")}
            </Typography>
            <Box className="dividerLine" />
          </Box>

          <FacebookLogin
            appId="1723338101781841"
            autoLoad={false}
            fields="first_name,last_name,email,picture"
            callback={handleFacebookLogin}
            render={(renderProps) => (
              <Button
                fullWidth
                variant="outlined"
                className="buttonOutlinedfb"
                onClick={renderProps.onClick}
                startIcon={
                  <SvgIcon className="fbIcon">
                    <path d="M22.675 0h-21.35C0.602 0 0 0.604 0 1.352v21.295C0 23.396 0.604 24 1.352 24H12.82v-9.294H9.692V10.51h3.127V7.797c0-3.1 1.892-4.792 4.656-4.792 1.325 0 2.465.099 2.795.143v3.24l-1.917.001c-1.506 0-1.796.717-1.796 1.767v2.314h3.593l-.468 3.195h-3.126V24h6.128C23.397 24 24 23.396 24 22.648V1.352C24 0.604 23.396 0 22.675 0z" />
                  </SvgIcon>
                }
              >
                {t("Log in with Facebook")}
              </Button>
            )}
          />

          <Button
            fullWidth
            variant="outlined"
            className="buttonOutlinedGoogle"
            startIcon={<GoogleIcon className="googleIcon" />}
            onClick={handleCustomGoogleLogin}
          >
            {t("Log in with Google")}
          </Button>

          <Grid
            container
            justifyContent="center"
            className="mt-8"
          >
            <Grid item>
              <Typography variant="body2" className="alreadyHaveAccount">
                {t("Don't have an account?")}
                <Link
                  component="button"
                  variant="body2"
                  onClick={handleSignUp}
                  className="loginLink"
                >
                  {t("Sign Up")}
                </Link>
              </Typography>
            </Grid>
          </Grid>

          <ForgotPasswordModal
            open={forgotPasswordOpen}
            onClose={handleForgotPasswordClose}
          />
        </div>
      </Modal>

      {createPortal(
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{
            width: "auto",
            zIndex: 2000,
          }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackbarSeverity}
            elevation={6}
            variant="filled"
            sx={{ borderRadius: 8 }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>,
        document.body
      )}
    </>
  );
};

export default LoginModal;
